import React from "react";
import { BRAND_SPECIALTIES } from "../data/brandMessaging";
import "../styles/BrandSpecialties.css";

const BrandSpecialties = ({ className = "", compact = false }) => (
  <div
    className={`brand-specialties${compact ? " brand-specialties--compact" : ""} ${className}`.trim()}
    role="list"
    aria-label="Our specialties"
  >
    {BRAND_SPECIALTIES.map(({ label, icon }) => (
      <span key={label} className="brand-specialty-badge" role="listitem">
        <span className="brand-specialty-icon" aria-hidden="true">
          {icon}
        </span>
        {label}
      </span>
    ))}
  </div>
);

export default BrandSpecialties;
